
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class StockAllocatedBOMGrid extends Serenity.EntityGrid<StockAllocatedBOMRow, any> {
        protected getColumnsKey() { return 'Inventory.StockAllocatedBOM'; }
        protected getDialogType() { return StockAllocatedBOMDialog; }
        protected getIdProperty() { return StockAllocatedBOMRow.idProperty; }
        protected getInsertPermission() { return StockAllocatedBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return StockAllocatedBOMRow.localTextPrefix; }
        protected getService() { return StockAllocatedBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}